import { BehaviorSubject, Observable } from 'rxjs';
import { Dependencies } from '../../configurations/dependencies/dependencies.interface';
import { changePasswordUsecase } from '../domain/usecases/authentication/changePassword.usecase';
import { emailSignInUsecase } from '../domain/usecases/authentication/emailSignIn.usecase';
import { emailSignUpUsecase } from '../domain/usecases/authentication/emailSignUp.usecase';
import { googleSignInUsecase } from '../domain/usecases/authentication/googleSignIn.usecase';
import { refreshTokenUsecase } from '../domain/usecases/authentication/refreshToken.usecase';
import { restoreAuthUsecase } from '../domain/usecases/authentication/restoreAuth.usecase';
import { signOutUsecase } from '../domain/usecases/authentication/signOut.usecase';
import { verifyTokenUsecase } from '../domain/usecases/authentication/verifyToken.usecase';
import { retrieveFightersUsecase } from '../domain/usecases/fighters/retrieveFighters.usecase';
import { retrieveFightsUsecase } from '../domain/usecases/fights/retrieveFights.usecase';
import { retrieveFighterImageUsecase } from '../domain/usecases/images/retrieveFighterImage.usecase';
import { retrieveSeasonFightsUsecase } from '../domain/usecases/seasonFights/retrieveSeasonFights.usecase';
import { retrieveSeasonsUsecase } from '../domain/usecases/seasons/retrieveSeasons.usecase';
import { retrieveGlobalTournamentDetailsUsecase } from '../domain/usecases/tournaments/retrieveGlobalTournamentDetails.usecase';
import { retrieveTournamentDetailsUsecase } from '../domain/usecases/tournaments/retrieveTournamentDetails.usecase';
import { retrieveTournamentsUsecase } from '../domain/usecases/tournaments/retrieveTournaments.usecase';
import { retrieveTournamentsByUserUsecase } from '../domain/usecases/tournaments/retrieveTournamentsByUser.usecase';
import { retrieveTournamentsCreatedByUserUsecase } from '../domain/usecases/tournaments/retrieveTournamentsCreatedByUser.usecase';
import { createUserProfileUsecase } from '../domain/usecases/users/createUserProfile.usecase';
import { deleteUserProfileUsecase } from '../domain/usecases/users/deleteUserProfile.usecase';
import { getUserProfileUsecase } from '../domain/usecases/users/getUserProfile.usecase';
import { updateUserProfileUsecase } from '../domain/usecases/users/updateUserProfile.usecase';
import { retrieveFighterFrequencyBySeasonUsecase } from '../domain/usecases/userSeasons/retrieveFighterFrequencyBySeason.usecase';
import { retrieveUserSeasonUsecase } from '../domain/usecases/userSeasons/retrieveUserSeason.usecase';
import { retrieveUsersTotalPointsBySeasonUsecase } from '../domain/usecases/userSeasons/retrieveUsersTotalPointsBySeason.usecase';
import { upsertUserSeasonUsecase } from '../domain/usecases/userSeasons/upsertUserSeason.usecase';
import { Action } from './action.type';
import { AppState } from './app.state';

export type EffectFunction = (
  action$: Observable<Action>,
  state$: BehaviorSubject<AppState>,
  dependencies: Dependencies,
) => Observable<Action>;

export const appEffects: Array<EffectFunction> = [
  retrieveFightersUsecase,
  retrieveFightsUsecase,
  emailSignInUsecase,
  googleSignInUsecase,
  emailSignUpUsecase,
  signOutUsecase,
  verifyTokenUsecase,
  refreshTokenUsecase,
  restoreAuthUsecase,
  getUserProfileUsecase,
  createUserProfileUsecase,
  retrieveSeasonFightsUsecase,
  updateUserProfileUsecase,
  deleteUserProfileUsecase,
  changePasswordUsecase,
  retrieveSeasonsUsecase,
  upsertUserSeasonUsecase,
  retrieveUserSeasonUsecase,
  retrieveFighterFrequencyBySeasonUsecase,
  retrieveUsersTotalPointsBySeasonUsecase,
  retrieveTournamentsUsecase,
  retrieveTournamentsByUserUsecase,
  retrieveTournamentsCreatedByUserUsecase,
  retrieveTournamentDetailsUsecase,
  retrieveGlobalTournamentDetailsUsecase,
  retrieveFighterImageUsecase,
];
